import React, {useContext, Suspense, useEffect, useRef, useState} from 'react'
import {
    Switch, Route, withRouter, Redirect, useLocation,
} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { MainContextProvider } from '../../context/MainContext'
import ModalConfig from '../../components/ModalContainer/ModalConfig'
import Layout from './Layout/Layout'
import Loader from '../../components/other/Loader'
import UseRoutes from './UseRoutes'
import NotFound from '../NotFound/NotFound'
import ErrorBoundary from '../../components/other/ErrorBoundry/ErrorBoundry'
import {PrivacyPolicy} from "../Modals/Auth/PrivacyPolicy/PrivacyPolicy";
import { IntercomProvider } from 'react-use-intercom'
import {
    ProviderTermsUsePrivacyPolicy
} from "../ServiceProvider/ProviderTermsUsePrivacyPolicy/ProviderTermsUsePrivacyPolicy";
import {NpsModal} from "../Modals/NpsModal/NpsModal";
import {useTimer} from "../../context/TimerContext";
import {
    ClientTermsUsePrivacyPolicy
} from "../../components/other/ClientTermsUsePrivacyPolicy/ClientTermsUsePrivacyPolicy";
import {CompanyType} from "../../types/company.type";
import customAxios from "../../service/api/interceptors";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {WelcomeAboard} from "../../components/other/WelcomeData/WelcomeAboard/WelcomeAboard";
import {closeAbroadModal} from "../../redux/slices/WelcomeChain";

function requestPermission() {
  if (window.Notification && Notification.permission !== "denied") {
    Notification.requestPermission().then();
  }
}

const AppStack:React.FC<any> = (props) => {

  const { isLoggedIn, loading, userData, setModalType, setModalData } = useContext(MainContextProvider)
    const welcomeChain = useSelector((state: RootState) => state.welcomeChain);
    const location = useLocation();
    const prevLocation = useRef<string>(location.pathname);
    const { stopTimer, setStartedTimerData } = useTimer();
    const [companies, setCompanies] = useState<CompanyType[]>([]);

    useEffect(() => {
        if (location.pathname.includes("/offer/")) {
            return
        }

        if (location.pathname.includes("/partner-request/")) {
            return
        }

        setStartedTimerData(null)
        stopTimer();

        // prevLocation.current = location.pathname;
    }, [location]);

  useEffect(() => {
    const { search, pathname } = window.location
    if(!isLoggedIn && !localStorage.getItem('accessToken')) {
        localStorage.setItem('initialLink', pathname + search)
    }
    
    if(isLoggedIn && !localStorage.getItem('push')) {
      localStorage.setItem('push', 'true')
      setTimeout(requestPermission, 3000)
    }
  }, [isLoggedIn])

  const { routes, startUrl } = UseRoutes()

  // @ts-ignore
    return (
      <div className={userData?.status.type_code === 200 ? 'lawyer_layout' : 'client_layout'}>
        <CSSTransition in={loading} timeout={200} classNames={'slide'} unmountOnExit>
          <Loader />
        </CSSTransition>
        { routes.length
          ? isLoggedIn
            ? (
              <IntercomProvider appId={'ylxg44qe'} apiBase={'https://api-iam.intercom.io'}>
                <Layout {...props}>
                  <Suspense fallback={<Loader />}>
                      {/* @ts-ignore */}
                    <ErrorBoundary>
                    <TransitionGroup className={'transition-group-screen'}>
                      <CSSTransition
                        key={props.location}
                        timeout={{ enter: 500, exit: 0 }}
                        classNames={'slide'}
                      >
                        <Switch>
                          {
                            routes.map(({ path, Component, exact }) => (
                              <Route
                                key={path}
                                exact={exact}
                                path={path}
                                component={Component}
                              />
                            ))
                          }
                          <Route exact path={'/'} render={() => (<Redirect to={startUrl} />)} />
                          <Route path={'*'} exact component={NotFound} />
                        </Switch>
                      </CSSTransition>
                    </TransitionGroup>
                    </ErrorBoundary>
                  </Suspense>
                </Layout>
              </IntercomProvider>
                )
            : (
              <IntercomProvider appId={'ylxg44qe'} apiBase={'https://api-iam.intercom.io'}>
                <Switch>
                  {
                    routes.map(({ path, Component, exact }) => (
                      <Route
                        key={path}
                        exact={exact}
                        path={path}
                        component={Component}
                      />
                    ))
                  }
                  <Redirect from={'*'} to={startUrl} />
                </Switch>
              </IntercomProvider>
            )
          : null}
        <IntercomProvider autoBoot={!!(window.location.host !== "localhost:3000" && window.location.host !== "stag.cabinet.legalnodes.co")} appId={'ylxg44qe'} apiBase={'https://api-iam.intercom.io'}>
          <div>
              <ModalConfig {...props} />
              {userData?.status.type_code === 100 && <ClientTermsUsePrivacyPolicy companies={userData?.companies} />}
          </div>
        </IntercomProvider>
        <ToastContainer />
        <PrivacyPolicy />
        {userData?.status.type_code === 100 && <NpsModal/>}
        {userData?.status.type_code === 200 && <ProviderTermsUsePrivacyPolicy />}
      </div>
  )
}

export default withRouter(AppStack)
